/**
 * Orvelar Gallery Fix
 * 1. Product pages: ensures all color images appear in gallery grid so swipe works.
 * 2. Collection /v: sets each card's aspect ratio to its image's natural ratio (no crop).
 */
(function () {

  /* ── Collection /v: adapt image ratio ───────────────────────────────────── */

  function isCollectionV() {
    return /^\/collections\/v(\/|$|\?|#)/.test(window.location.pathname);
  }

  function applyAdaptRatioToCard(cardGallery) {
    var img = cardGallery.querySelector('img');
    if (!img) return;

    function setRatio() {
      if (img.naturalWidth && img.naturalHeight) {
        var ratio = img.naturalWidth / img.naturalHeight;
        cardGallery.style.setProperty('--gallery-aspect-ratio', String(ratio));
      }
    }

    if (img.complete && img.naturalWidth) {
      setRatio();
    } else {
      img.addEventListener('load', setRatio, { once: true });
    }
  }

  function patchCollectionVRatios() {
    if (!isCollectionV()) return;

    // Patch all currently rendered cards
    document.querySelectorAll('[data-image-ratio="square"], [data-image-ratio]').forEach(function (el) {
      applyAdaptRatioToCard(el);
    });

    // Watch for infinite-scroll adding more cards
    var grid = document.querySelector('.main-collection, product-grid, [data-collection-grid]')
      || document.querySelector('main');
    if (!grid) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node.querySelectorAll) return;
          node.querySelectorAll('[data-image-ratio]').forEach(applyAdaptRatioToCard);
          if (node.hasAttribute && node.hasAttribute('data-image-ratio')) {
            applyAdaptRatioToCard(node);
          }
        });
      });
    }).observe(grid, { childList: true, subtree: true });
  }

  /* ── Product page: inject all color images into gallery ─────────────────── */

  function getProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle, cb) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () {});
  }

  function buildGridItem(media, template) {
    var item = template.cloneNode(true);
    var img = item.querySelector('img');
    if (!img) return null;

    var base = media.src.replace(/\?.*/, '');
    img.src = base + '?width=800';
    img.srcset = [400, 600, 800, 1000, 1200].map(function (w) {
      return base + '?width=' + w + ' ' + w + 'w';
    }).join(', ');
    img.alt = media.alt || '';
    img.removeAttribute('data-view-transition-type');

    return item;
  }

  function patchProductGrid(gallery, product) {
    var grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('li'));
    if (items.length === 0) return;
    var imageCount = product.media.filter(function (m) { return m.media_type === 'image'; }).length;
    if (items.length >= imageCount) return;

    var existingNames = new Set();
    items.forEach(function (li) {
      var img = li.querySelector('img');
      if (img) existingNames.add(img.src.replace(/\?.*/, '').split('/').pop());
    });

    var template = items[0];
    product.media.forEach(function (media) {
      if (media.media_type !== 'image') return;
      var name = media.src.replace(/\?.*/, '').split('/').pop();
      if (existingNames.has(name)) return;
      var newItem = buildGridItem(media, template);
      if (newItem) grid.appendChild(newItem);
    });
  }

  function patchGallery(gallery) {
    var handle = getProductHandle();
    if (!handle) return;
    fetchProduct(handle, function (product) {
      patchProductGrid(gallery, product);
    });
  }

  function watchForGalleryReplacements() {
    var section = document.querySelector('.shopify-section:has(media-gallery)')
      || document.querySelector('product-information')
      || document.querySelector('.shopify-section');
    if (!section) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node.querySelector) return;
          var g = (node.tagName === 'MEDIA-GALLERY') ? node : node.querySelector('media-gallery');
          if (g) patchGallery(g);
        });
      });
    }).observe(section, { childList: true, subtree: true });
  }

  function initProductPage() {
    if (!getProductHandle()) return;
    var gallery = document.querySelector('media-gallery');
    if (gallery) patchGallery(gallery);
    watchForGalleryReplacements();
  }

  /* ── Bootstrap ──────────────────────────────────────────────────────��────── */

  function init() {
    patchCollectionVRatios();
    initProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
